// Lightweight per-route meta manager (no external deps).
const SITE = {
  title: "TL Auctions — Live & Online Auctions in Dallas–Fort Worth",
  description:
    "Licensed & bonded Texas auctioneers since 1996. Live, onsite and online auctions across Dallas–Fort Worth — equipment, vehicles, machinery and estates.",
};

const ensure = (attr, key) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  return el;
};

export function setMeta({ title, description, image, path } = {}) {
  const t = title || SITE.title;
  const d = description || SITE.description;
  document.title = t;
  const url = window.location.origin + (path || window.location.pathname);
  const pairs = [
    ["name", "description", d],
    ["property", "og:title", t],
    ["property", "og:description", d],
    ["property", "og:url", url],
    ["name", "twitter:title", t],
    ["name", "twitter:description", d],
  ];
  if (image) {
    pairs.push(["property", "og:image", image], ["name", "twitter:image", image]);
  }
  pairs.forEach(([a, k, v]) => ensure(a, k).setAttribute("content", v));
}
